import { clearingApi } from "../../config/apiConfig";

// PAY-11 / CLR-150 — additive wallet-credit fields on credit-note validation
// responses. Fields are optional on the wire so a Clearing build that has not
// yet rolled out CLR-150 keeps working unchanged. This helper applies the
// canonical defaults at the parsing boundary so the rendering layer can branch
// on them safely.
export const normalizeWalletCreditFields = (response) => {
  if (!response) return response;
  return {
    ...response,
    walletCreditSum: response.walletCreditSum ?? 0.0,
    walletCreditByCustomer: response.walletCreditByCustomer ?? null,
    refundsAcknowledgedV1: response.refundsAcknowledgedV1 ?? false,
  };
};

export const clearingValidationEmpBills = async ({ month, year, eroundSum, enforceTitlePrefix, skipWithoutServiceDate }) => {
  if (!month || !year) {
    console.log("No month and/or year provided");
    return;
  }

  let endpoint = `validation/validate-emp-bills?month=${month}&year=${year}&enforce-title-prefix=${enforceTitlePrefix}&skip-without-service-date=${skipWithoutServiceDate}`;
  if (eroundSum) {
    endpoint += `&eround-sum=${eroundSum}`;
  }

  try {
    const response = await clearingApi.get(endpoint);
    return response?.data;
  } catch (e) {
    console.error("Failed to validate EMP bills", e);
    throw new Error(e?.response?.data?.error ?? "Failed to complete EMP bills validation.");
  }
};

export const clearingValidateVat = async ({ empBills, month, year, enforceTitlePrefix, skipWithoutServiceDate }) => {
  try {
    const endpoint = `validation/validate-vat?month=${month}&year=${year}&enforce-title-prefix=${enforceTitlePrefix}&skip-without-service-date=${skipWithoutServiceDate}`;
    const response = await clearingApi.post(endpoint, empBills);
    return response?.data;
  } catch (e) {
    console.error("Failed to validate VAT", e);
    return null;
  }
};

export const clearingFinalizeAndSendEmpBills = async ({ empBills, ignoredWarningDocumentIds, month, year, enforceTitlePrefix, skipWithoutServiceDate }) => {
  try {
    const response = await clearingApi.post("validation/finalize-and-send-emp-bills", {
      empBills,
      ignoredWarningDocumentIds,
      month,
      year,
      enforceTitlePrefix,
      skipWithoutServiceDate,
    });
    return response?.data;
  } catch (e) {
    console.error("Failed to finalize and send EMP bills", e);
    return null;
  }
};


export const clearingValidateCreditNoteVat = async ({ creditNotes, month, year, enforceTitlePrefix, skipWithoutServiceDate }) => {
  try {
    const endpoint = `validation/validate-credit-note-vat?month=${month}&year=${year}&enforce-title-prefix=${enforceTitlePrefix}&skip-without-service-date=${skipWithoutServiceDate}`;
    const response = await clearingApi.post(endpoint, creditNotes);
    return response?.data;
  } catch (e) {
    console.error("Failed to validate credit note VAT", e);
    return null;
  }
};

export const clearingValidationByMonth = async ({ month, year, eroundSum, deletedCreditNotesSum, enforceTitlePrefix, skipWithoutServiceDate, documentDateMonth, documentDateYear }) => {
  if (!month || !year) {
    console.log("No month and/or year provided");
    return;
  }

  let endpoint = `validation/validate-month?month=${month}&year=${year}&deleted-credit-notes-sum=${deletedCreditNotesSum}&enforce-title-prefix=${enforceTitlePrefix}&skip-without-service-date=${skipWithoutServiceDate}`;
  if (eroundSum) {
    endpoint += `&eround-sum=${eroundSum}`;
  }
  if (documentDateMonth && documentDateYear) {
    endpoint += `&document-date-month=${documentDateMonth}&document-date-year=${documentDateYear}`;
  }

  try {
    const response = await clearingApi.get(endpoint);
    return normalizeWalletCreditFields(response?.data);
  } catch (e) {
    console.error("Failed to validate credit notes", e);
    throw new Error(e?.response?.data?.error ?? "Failed to complete clearing validation.");
  }
};
